import { createContext } from 'react';

export const schedulerContextDefault = {
  leadID: '',
  contactID: '',
};

export const SchedulerContext = createContext(schedulerContextDefault);